import React,  {useState, useEffect} from 'react';
import './Reset.css'
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import Cards from './components/Cards';
import About from './components/About';
import Footer from './components/Footer';
import HeroSection from './components/HeroSection';
import locomotiveScroll from 'locomotive-scroll';
import Loading from './components/Loading';


function App() {
  
/*Locomotive Scroll*/
  const scrollRef = React.createRef();

  useEffect(() => {
    const scroll = new locomotiveScroll({
      el: scrollRef.current,
      smooth: true,
      getDirection: true,
      getSpeed: true,
      lerp: 0.04, // Linear Interpolation, 0 > 1 // Try 0.01
      multiplier: 1.1, // Effect Multiplier
      reloadOnContextChange: true,
      touchMultiplier: 2,    
      smartphone: {
        smooth: false,
          breakpoint: 767
      },
      tablet: {
          smooth: !1,
          breakpoint: 1024
      },
      });
  });

  return(
        <>
        <Loading/>
        <video src="/videos/webvid.mp4" autoPlay loop muted />
        <div className='wrapper' data-scroll-container ref={scrollRef}>
          <section data-scroll-section>
            <HeroSection/>
          </section>
          <section data-scroll-section >
            <About />
          </section>
          <section data-scroll-section>
            <Cards/>
          </section>
          <section data-scroll-section className='footer__container'>
            <Footer/>
          </section>
        </div>
        </> 
        );
}    

export default App;
